import { useState, } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// ...other imports...
import { Box, Button, Typography } from '@mui/material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import useResponsive from '../../hooks/useResponsive';
import { useFilter } from '../../context/FilterContext';


const sidebarItems = [
  { label: "My Profile", path: "/my-profile" },
  { label: "My Orders", path: "/my-profile/orders" },
  { label: "My Cart", path: "/cart" },
  { label: "Shipping Details", path: "/my-profile/shipping" },
  { label: "Logout", path: "logout" }
];

const MyProfile = () => {
  const { isSmallScreen } = useResponsive();
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutOpen, setLogoutOpen] = useState(false);
  const { setIsLoggedIn ,setProfile} = useFilter();

  const removeToken = () => {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const handleLogout = () => {
    removeToken();
    setIsLoggedIn(false)
    setLogoutOpen(false);
    navigate('/login');
    setProfile({ name: "", phone: "", email: "", image: "" })
  }

  const isActive = (path) => {
    // For the profile page, we need an exact match
    if (path === "/my-profile") {
      return location.pathname === path || location.pathname === "/my-profile/" || location.pathname.endsWith("/my-profile");
    }
    // For other paths, check if the current path starts with the item's path
    return location.pathname.startsWith(path);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: '#fafafa', mx: 'auto' }}>
      {isSmallScreen &&
        <Box sx={{
          display: 'flex',
          width: '100%',
          bgcolor: '#FAFAFA',
          justifyContent: 'space-around',
          alignItems: 'center',
          py: 3
        }}>
          {/* My Profile */}
          <Box
            onClick={(e) => {
              e.preventDefault();
              if (!isActive("/my-profile")) {
                navigate("/my-profile", { preventScrollReset: true });
              }
            }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              color: isActive("/my-profile") ? '#CB4422' : '#222',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
            component="a"
            href="/my-profile"
          >
            <i className="fa-solid fa-user" style={{ fontSize: 22 }}></i>
          </Box>
          {/* My Orders */}
          <Box
            onClick={(e) => {
              e.preventDefault();
              if (!isActive("/my-profile/orders")) {
                navigate("/my-profile/orders", { preventScrollReset: true });
              }
            }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              color: isActive("/my-profile/orders") ? '#CB4422' : '#222',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
            component="a"
            href="/my-profile/orders"
          >
            <i className="fa-solid fa-truck" style={{ fontSize: 22 }}></i>
          </Box>
          {/* My Cart */}
          <Box
            component="a"
            href="/cart"
            onClick={(e) => {
              e.preventDefault();
              if (!isActive("/cart")) {
                window.history.pushState({}, '', '/cart');
                window.dispatchEvent(new Event('popstate'));
              }
            }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              color: isActive("/cart") ? '#CB4422' : '#222',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
          >
            <i className="fa-solid fa-shopping-cart" style={{ fontSize: 22 }}></i>
          </Box>
          {/* Shipping Details */}
          <Box
            onClick={(e) => {
              e.preventDefault();
              if (!isActive("/my-profile/shipping")) {
                navigate("/my-profile/shipping", { preventScrollReset: true });
              }
            }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              color: isActive("/my-profile/shipping") ? '#CB4422' : '#222',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
            component="a"
            href="/my-profile/shipping"
          >
            <i className="fa-solid fa-address-book" style={{ fontSize: 22 }}></i>
          </Box>
        </Box>
      }
      <Box sx={{ display: 'flex', minHeight: '80vh', bgcolor: '#fafafa', px: 1, py: 2 }}>
        {/* Sidebar */}
        {!isSmallScreen && <Box sx={{ minWidth: 150, width: 250, mr: 4 }}>
          {sidebarItems.map(item => (
            <Button
              key={item.label}
              fullWidth
              variant={isActive(item.path) ? "contained" : "text"}
              onClick={() => {
                if (item.external) {
                  window.location.href = item.path;
                } else if (item.label === "Logout") {
                  setLogoutOpen(true); // Show confirmation dialog
                } else {
                  navigate(item.path);
                }
              }}
              sx={{
                justifyContent: 'flex-start',
                mb: 1,
                bgcolor: isActive(item.path) ? "#ededed" : "transparent",
                color: item.label === "Logout" ? "#d32f2f" : "#222",
                fontWeight: 500,
                borderRadius: 2,
                boxShadow: 'none',
                textTransform: 'none',
                '&:hover': {
                  bgcolor: "#ededed",
                  color: item.label === "Logout" ? "#fff" : "#222",
                  backgroundColor: item.label === "Logout" ? "#d32f2f" : "#ededed"
                }
              }}
              disableElevation
            >
              {item.label}
            </Button>
          ))}
        </Box>}

        {/* Main Content */}
        <Box sx={{ flex: 1 }}>
          <Outlet />
        </Box>
      </Box>

      {/* Logout Confirmation Dialog */}
      <Dialog open={logoutOpen} PaperProps={{
        sx: {
          minWidth: 350,   // Increase width
          maxWidth: 500,   // Optional: set a max width
          minHeight: 180,  // Increase height
          p: 2             // Optional: add padding
        }
      }} onClose={() => setLogoutOpen(false)}>
        <DialogTitle variant='h4' sx={{ fontWeight: 600 }}>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography variant='h3'>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            color="error"
            variant="contained"
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>);
};

export default MyProfile;